import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3e854f36&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=3e854f36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/codebuild/output/src3752597510/src/frontend/src/components/TheHeader.vue').default,TheFooter: require('/codebuild/output/src3752597510/src/frontend/src/components/TheFooter.vue').default})
